import number0 from "../../../../assets/casino/numbers/0.png";
import number00 from "../../../../assets/casino/numbers/00.png";
import number1 from "../../../../assets/casino/numbers/1.png";
import number2 from "../../../../assets/casino/numbers/2.png";
import number3 from "../../../../assets/casino/numbers/3.png";
import number4 from "../../../../assets/casino/numbers/4.png";
import number5 from "../../../../assets/casino/numbers/5.png";
import number6 from "../../../../assets/casino/numbers/6.png";
import number7 from "../../../../assets/casino/numbers/7.png";
import number8 from "../../../../assets/casino/numbers/8.png";
import number9 from "../../../../assets/casino/numbers/9.png";
import number10 from "../../../../assets/casino/numbers/10.png";
import number11 from "../../../../assets/casino/numbers/11.png";
import number12 from "../../../../assets/casino/numbers/12.png";
import number13 from "../../../../assets/casino/numbers/13.png";
import number14 from "../../../../assets/casino/numbers/14.png";
import number15 from "../../../../assets/casino/numbers/15.png";
import number16 from "../../../../assets/casino/numbers/16.png";
import number17 from "../../../../assets/casino/numbers/17.png";
import number18 from "../../../../assets/casino/numbers/18.png";
import number19 from "../../../../assets/casino/numbers/19.png";
import number20 from "../../../../assets/casino/numbers/20.png";
import number21 from "../../../../assets/casino/numbers/21.png";
import number22 from "../../../../assets/casino/numbers/22.png";
import number23 from "../../../../assets/casino/numbers/23.png";
import number24 from "../../../../assets/casino/numbers/24.png";
import number25 from "../../../../assets/casino/numbers/25.png";
import number26 from "../../../../assets/casino/numbers/26.png";
import number27 from "../../../../assets/casino/numbers/27.png";
import number28 from "../../../../assets/casino/numbers/28.png";
import number29 from "../../../../assets/casino/numbers/29.png";
import number30 from "../../../../assets/casino/numbers/30.png";
import number31 from "../../../../assets/casino/numbers/31.png";
import number32 from "../../../../assets/casino/numbers/32.png";
import number33 from "../../../../assets/casino/numbers/33.png";
import number34 from "../../../../assets/casino/numbers/34.png";
import number35 from "../../../../assets/casino/numbers/35.png";
import number36 from "../../../../assets/casino/numbers/36.png";

const rouletteNumberAssets = {
  "0": number0,
  "00": number00,
  "1": number1,
  "2": number2,
  "3": number3,
  "4": number4,
  "5": number5,
  "6": number6,
  "7": number7,
  "8": number8,
  "9": number9,
  "10": number10,
  "11": number11,
  "12": number12,
  "13": number13,
  "14": number14,
  "15": number15,
  "16": number16,
  "17": number17,
  "18": number18,
  "19": number19,
  "20": number20,
  "21": number21,
  "22": number22,
  "23": number23,
  "24": number24,
  "25": number25,
  "26": number26,
  "27": number27,
  "28": number28,
  "29": number29,
  "30": number30,
  "31": number31,
  "32": number32,
  "33": number33,
  "34": number34,
  "35": number35,
  "36": number36,
};

export function getRouletteNumberAsset(value) {
  return rouletteNumberAssets[String(value)] || null;
}

export default rouletteNumberAssets;
